import { memo } from 'react';
import { Avatar, Box, Grid, Hidden } from '@lingoda/ui';
import { type AvatarProps } from './common';

interface Props {
    teacher: AvatarProps | undefined;
}

const TeacherParticipantComponent = ({ teacher }: Props) => (
    <>
        <Hidden lgDown>
            {teacher ? (
                <Grid item>
                    <Box sx={{ mr: 2 }}>
                        <Avatar size={40} src={teacher.src}>
                            {teacher.firstName}
                        </Avatar>
                    </Box>
                </Grid>
            ) : (
                <Grid item>
                    <Box sx={{ mr: 2, visibility: 'hidden' }}>
                        <Avatar size={40} />
                    </Box>
                </Grid>
            )}
        </Hidden>
        <Hidden lgUp>
            {teacher ? (
                <Grid item>
                    <Box sx={{ mr: 0.5 }}>
                        <Avatar size={40} src={teacher.src}>
                            {teacher.firstName}
                        </Avatar>
                    </Box>
                </Grid>
            ) : null}
        </Hidden>
    </>
);

export const TeacherParticipant = memo(TeacherParticipantComponent);
